import { Employee } from "@/v2/types";
import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";
import FindAllArOfficeStaff from "@/v2/api/employee/FindAllArOfficeStaff";

interface ArEmployeeFilterComboBoxProps {
    value?: string; // The selected employee ID
    onChange?: (employeeId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function ArEmployeeFilterComboBox({
    value,
    onChange,
    placeholder = "Select ar coordinator...",
    disabled = false,
    className,
    label = "AR Coordinator",
}: ArEmployeeFilterComboBoxProps) {
    const handleSelect = (item: Employee | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderEmployeeItem = (employee: Employee) => (
        <div className="flex flex-col">
            <span>{employee.full_name}</span>
            {employee.iqama && (
                <span className="text-xs text-muted-foreground">
                    {employee.iqama}
                </span>
            )}
            {employee.trade && (
                <span className="text-xs text-muted-foreground">
                    Trade : {employee.trade[0]}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<Employee>
            label={label}
            labelAlign="items-start"
            queryKey={["ar-office-staff"]}
            queryFn={async ({ pageParam, search, limit, filter }) =>
                FindAllArOfficeStaff({
                    skip: pageParam,
                    limit,
                    search,
                    filter,
                })
            }
            getDisplayValue={(employee: Employee) => employee.full_name}
            renderItem={renderEmployeeItem}
            placeholder={placeholder}
            searchPlaceholder="Search ar coordinator..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
